/* models/widgets/toggle.js */ function _(require, module, exports) {
    var tslib_1 = require(113) /* tslib */;
    var abstract_button_1 = require(474) /* ./abstract_button */;
    var dom_1 = require(163) /* ../../core/dom */;
    var p = require(121) /* ../../core/properties */;
    var mixins_1 = require(240) /* ../../styles/mixins */;
    var ToggleView = /** @class */ (function (_super) {
        tslib_1.__extends(ToggleView, _super);
        function ToggleView() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ToggleView.prototype.connect_signals = function () {
            var _this = this;
            _super.prototype.connect_signals.call(this);
            this.connect(this.model.properties.active.change, function () { return _this._update_active(); });
        };
        ToggleView.prototype.render = function () {
            _super.prototype.render.call(this);
            this._update_active();
        };
        ToggleView.prototype.click = function () {
            this.model.active = !this.model.active;
            _super.prototype.click.call(this);
        };
        ToggleView.prototype._update_active = function () {
            dom_1.classes(this.button_el).toggle(mixins_1.bk_active, this.model.active);
        };
        return ToggleView;
    }(abstract_button_1.AbstractButtonView));
    exports.ToggleView = ToggleView;
    ToggleView.__name__ = "ToggleView";
    var Toggle = /** @class */ (function (_super) {
        tslib_1.__extends(Toggle, _super);
        function Toggle(attrs) {
            return _super.call(this, attrs) || this;
        }
        Toggle.init_Toggle = function () {
            this.prototype.default_view = ToggleView;
            this.define({
                active: [p.Boolean, false],
            });
            this.override({
                label: "Toggle",
            });
        };
        return Toggle;
    }(abstract_button_1.AbstractButton));
    exports.Toggle = Toggle;
    Toggle.__name__ = "Toggle";
    Toggle.init_Toggle();
}
